import { Form } from 'react-bootstrap';
import './styles.scss';
import { useField } from 'formik';

export default function Switch({ hasDefault = false, onChange, id, ...props }) {
  const [field, , helpers] = useField(props);

  const handleChange = (evt) => {
    field.onChange(field.name);

    helpers.setValue(!field.value);

    if (onChange) onChange(evt, field);
  };

  return (
    <div className="Switch">
      <Form.Check
        {...props}
        {...field}
        id={id || field.name}
        checked={field.value}
        onChange={handleChange}
        type="switch"
        className={!hasDefault ? 'Switch__input' : ''}
      />
    </div>
  );
}
